/**
 * AG Grid License Key
 *
 * This is the license key provided by AG Grid for enterprise use.
 *
 * Current expiration date: 14 February 2026
 *
 * The expiration of this key does not require the removal of enterprise features,
 * but does restrict the ability to upgrade to future versions of AG Grid Enterprise
 * that were released after the expiration of this license key.
 *
 * NOTE: This key is not considered a secret and must be disclosed to the frontend
 * to enable the enterprise features of AG Grid.
 */
export const agGridLicenseKey =
    'Using_this_{AG_Grid}_Enterprise_key_{AG-074123}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{The_Predictive_Index}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{predictiveindex}_only_for_{12}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{predictiveindex}_need_to_be_licensed___{predictiveindex}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{14_February_2026}____[v3]_[01]_MTc3MTAyNzIwMDAwMA==87da000e18689de543d80b008a88bd78';
